import { NgModule } from '@angular/core';

import { environment } from '../environments/environment';

// ANGULAR DEPENDECIES
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

// SHARED SERVICES
import { SharedModule } from './shared/shared.module';

// NGRX DEPENDECIES
import { StoreRouterConnectingModule, RouterStateSerializer } from '@ngrx/router-store';
import { StoreModule, MetaReducer } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { reducers } from './shared/store/index';
import { CustomSerializer } from './shared/store/reducers/router.reducer';

// not used in production
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { storeFreeze } from 'ngrx-store-freeze';
export const metaReducers: MetaReducer<any>[] = !environment.production ? [storeFreeze] : [];

// BOOTSTRAP COMPONENTS
import {
  AlertModule,
  ModalModule,
  CollapseModule,
  AccordionModule,
  BsDropdownModule,
  ButtonsModule,
  TooltipModule,
  BsDatepickerModule,
  TimepickerModule
} from 'ngx-bootstrap';

// MAIN APP COMPONENTS
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,

    // SHARED
    SharedModule.forRoot(),

    // ROUTING
    AppRoutingModule, // must be after submodules

    // NGRX
    StoreModule.forRoot(reducers, { metaReducers }),
    StoreRouterConnectingModule,
    EffectsModule.forRoot([]),
    !environment.production
      ? StoreDevtoolsModule.instrument({
          maxAge: 10 // number of states to retain
        })
      : [],

    // BOOTSTRAP MODULES
    AlertModule.forRoot(),
    ModalModule.forRoot(),
    CollapseModule.forRoot(),
    AccordionModule.forRoot(),
    BsDropdownModule.forRoot(),
    ButtonsModule.forRoot(),
    TooltipModule.forRoot(),
    TimepickerModule.forRoot(),
    BsDatepickerModule.forRoot()
  ],
  providers: [{ provide: RouterStateSerializer, useClass: CustomSerializer }],
  bootstrap: [AppComponent]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts